import React, { useEffect, useState, useRef } from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
import "../style.scss";
import { Helmet } from "react-helmet";
import { getIAPRegistrationData, RegisterRegistration, getRegistrationMedia } from '../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formDataGenerator } from "../../../../../utils/common";
import ReactPlayer from "react-player";
import cookie from 'react-cookies';

const Registration = (props) => {
  const { getIAPRegistrationData, 
    IAPWomenData, 
    // RegisterRegistration, 
    // RegisterDataaa, 
    history,
    getRegistrationMedia,
    registrationMedia 
  } = props;

  // const [mobileNumber, setMobileNumber] = useState("");
  const [womenData, setwomenData] = useState();
  const [language, setLanguage] = useState("English");
  // const [sessionTime, setSessionTime] = useState();
  // const [sessionDate, setSessionDate] = useState();
  // const [dataSubmited, setdataSubmited] = useState();
  const [metaData, setmetaData] = useState();
  const [isDesktop, setIsDesktop] = useState(true)
  // const [sipEmailData, setsipEmailData] = useState();
  // const [sessionDuration, setsessionDuration] = useState();
  // const [lateResponse, setlateResponse] = useState(false);
  const [langData, setLangData] = useState();
  const [selectedLang, setSelectedLang] = useState(false);

  useEffect(() => {
    let tBot = document.querySelector('.bot');
    if (tBot) tBot.style.display = 'none';
  }, []);

  // useEffect(() => {
  //   if (dataSubmited && dataSubmited.email) {
  //     setsipEmailData(dataSubmited.email);
  //   }
  //   // if (dataSubmited && dataSubmited.sessionDuration) {
  //   //   setsessionDuration(dataSubmited.sessionDuration)
  //   // }
  // }, [dataSubmited]);

  // useEffect(() => {
  //   if (sipEmailData) {
  //     cookie.save('sipsaheliemail', sipEmailData, { path: '/' });
  //     cookie.save('sipsahelilanguage', language, { path: '/' });
  //   }
  //   if(milliseconds){
  //     const timeout = setTimeout(() => {
  //       {language == "Hindi" ? 
  //         history.push('/quiz/sipsaheli')
  //         :history.push('/quiz/sipsaheli');}
  //         handleExitFullscreen();
  //     }, milliseconds);
  //     return () => clearTimeout(timeout);
  //   }
  // }, [sipEmailData]);

  // const formik = useFormik({
  //   initialValues: {
  //     firstname: '',
  //     // lastname: '',
  //     floatingemail: '',
  //     mobile: '',
  //     // sessionDay: '',
  //     // sessionTime: '',
  //     sessionLanguage: 'English',
  //   },
  //   validationSchema: Yup.object({
  //     firstname: Yup.string()
  //       .required('Name is required'),
  //     // lastname: Yup.string()
  //     //   .required('Last name is required'),
  //     floatingemail: Yup.string()
  //       .required('Email is required')
  //       .email('Invalid email address'),
  //     mobile: Yup.string()
  //       .matches(/^\d{10}$/, 'Must be exactly 10 digits')
  //       .required('Mobile number is required'),
  //     // sessionDay: Yup.string().required('Session day is required'),
  //     // sessionTime: Yup.string().required('Session time is required'),
  //     sessionLanguage: Yup.string().required('Session language is required'),
  //   }),
  //   onSubmit: (values, { resetForm }) => {
  //     const payload = {
  //       title: "Sip Saheli Registration",
  //       name: values.firstname,
  //       // lastName: values.lastname,
  //       language: values.sessionLanguage,
  //       mobileNumber: values.mobile,
  //       email: values.floatingemail,
  //       // sessionDate: "",
  //       // sessionTime: "",
  //       // webinarId: womenData && womenData.sessionData &&
  //       //   womenData.sessionData.find(item => item.webinarDate == values.sessionDay)
  //       //     .timeSlots.find(data => data.time == values.sessionTime)
  //       //     .webinarID,
  //     }
  //     RegisterRegistration(formDataGenerator(payload));
  //     setMobileNumber("");
  //   },
  // });

  // useEffect(() => {
  //   if (formik.values.mobile) {
  //     setMobileNumber(formik.values.mobile);
  //   }
  // }, [formik.values.mobile]);
  // useEffect(() => {
  //   if (formik.values.sessionTime) {
  //     setSessionTime(formik.values.sessionTime);
  //   }
  // }, [formik.values.sessionTime])
  // useEffect(() => {
  //   if (formik.values.sessionDay) {
  //     setSessionDate(formik.values.sessionDay);
  //     formik.setFieldValue("sessionTime", "");
  //   }
  // }, [formik.values.sessionDay])

  // useEffect(()=>{
  //   if(formik.values.sessionLanguage){
  //     setLanguage(formik.values.sessionLanguage);
  //     // formik.setFieldValue("sessionTime","");
  //     // formik.setFieldValue("sessionDay","");
  //   }
  // },[formik.values.sessionLanguage])
  useEffect(() => {
    let formData = {
      langcode: language === "English" ? 'en' : 'hi',
    };
    getIAPRegistrationData({}, formDataGenerator(formData));
  }, [language]);

  useEffect(() => {
    if (IAPWomenData) {
      setwomenData(IAPWomenData)
    }
    if (IAPWomenData && IAPWomenData.meta) {
      setmetaData(IAPWomenData.meta)
    }
  }, [IAPWomenData])
  // useEffect(() => {
  //   if (RegisterDataaa) {
  //     setdataSubmited(RegisterDataaa);
  //   }
  // }, [RegisterDataaa])
  useEffect(() => {
    const handleWindowSizeChange = () => {
      setIsDesktop(window.innerWidth > 767);
    };
    window.addEventListener('resize', handleWindowSizeChange);
    handleWindowSizeChange(); // Call the function initially to set the initial state
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);
  // const convertToMilliseconds = (timeString) => {
  //   if (timeString != null && timeString !== undefined && timeString !== '') {
  //     const timeParts = timeString.split(':').map(Number);
  
  //     let hours = 0, minutes = 0, seconds = 0;
  
  //     // Depending on the number of parts, assign them to hours, minutes, and seconds
  //     if (timeParts.length === 3) {
  //       [hours, minutes, seconds] = timeParts;
  //     } else if (timeParts.length === 2) {
  //       [minutes, seconds] = timeParts;
  //     } else if (timeParts.length === 1) {
  //       [seconds] = timeParts;
  //     }
  
  //     // Calculate total milliseconds
  //     const totalMilliseconds = ((hours * 3600) + (minutes * 60) + seconds) * 1000;
  //     return totalMilliseconds;
  //   }
  // };
  // const milliseconds = convertToMilliseconds(dataSubmited && dataSubmited.sessionDuration);
  // const handleRegister=()=>{
  //   if(dataSubmited){
  //     setlateResponse(true);
  //   }
  // }

  const playerWrapperRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleFullscreen = () => {
    const container = playerWrapperRef.current;

    if (container.requestFullscreen) {
      container.requestFullscreen();
    } else if (container.mozRequestFullScreen) {
      container.mozRequestFullScreen();
    } else if (container.webkitRequestFullscreen) {
      container.webkitRequestFullscreen();
    } else if (container.msRequestFullscreen) {
      container.msRequestFullscreen();
    }
    setIsFullscreen(true);
  };

  const handleExitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    setIsFullscreen(false);
  };

  const handleFullscreenChange = () => {
    if (!document.fullscreenElement) {
      setIsFullscreen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  const handleclicklanguage=(lang)=>{
    setSelectedLang(true);
    setLanguage(lang);
    window.scrollTo(0,0);
  }
  useEffect(() => {
    getRegistrationMedia();
  }, []);

  useEffect(() => {
    if (registrationMedia) {
      setLangData(registrationMedia);
    }
  }, [registrationMedia])

  return (
    <div className="wrapper">
      {metaData ? (
        <Helmet>
          <title>{metaData && metaData.title ? metaData.title : ""}</title>
          <meta name="description"
            content={
              metaData && metaData.description ? metaData.description : ""
            }
          />
          <meta name="keywords"
            content={
              metaData && metaData.keywords ? metaData.keywords : ""
            }
          />
          <meta property="og:title"
            content={
              metaData && metaData.og_title ? metaData.og_title : ""
            }
          />
          <meta property="og:description"
            content={
              metaData && metaData.og_description ? metaData.og_description : ""
            }
          />
          <meta property="og:image"
            content={
              metaData && metaData.og_image ? metaData.og_image : ""
            }
          />
          <meta property="og:url"
            content={
              metaData && metaData.og_url ? metaData.og_url : ""
            }
          />
        </Helmet>
      ) : ("")}
      <section className="aboutHead">
        <div className="container">
          <div className="d-flex">
            <h1 className="me-auto">
              SIP <span>Saheli</span>
            </h1>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                {/* <li className="breadcrumb-item">
                  <a href="">Investement Institute</a>
                </li> */}
                <li
                  className="breadcrumb-item active breadcolor"
                  aria-current="page"
                >
                  SIP Saheli
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>

      <section>
      {/* {(dataSubmited && dataSubmited == "Register") ? */}
      {selectedLang === true ?
        <div className="container my-5 d-flex justify-content-center">

          {langData && langData.length > 0 && langData.map((item) => {
            return(
              <>
                {item && item.language === language ?
                  <div className="registerplayer" ref={playerWrapperRef}>
                    <ReactPlayer
                      url={item && item.video && item.video.url}
                      controls={false}
                      className={isFullscreen ? "player videoplayer" : "videoplayer"}
                      muted={false}
                      playing={true}
                      onEnded={() => {history.push('/quiz-sipsaheli/events'); handleExitFullscreen(); cookie.save('isRegistration', true, { path: '/' }); cookie.save('sipsahelilanguage', language, { path: '/' });
                    }}
                    />
                    {isFullscreen ?
                    <img src="/images/New/SipSaheli/fullscreen.png" width="27" height="27" onClick={handleExitFullscreen} className="fullscreen"/>
                    // <svg  width="27" height="27" data-v-71c99c82="" version="1.1" viewBox="0 0 24 24" class="svg-icon svg-fill fullscreen cursorOtp" focusable="false"><path pid="0" d="M20.664 19.114l-2.806-2.854L19.845 14H14v5.947l2.104-2.141 2.806 2.854a1.155 1.155 0 001.637 0 .96.96 0 00.117-1.546zM6.197 7.864l-2.141 2.14h5.947V4.059L7.862 6.2 5.007 3.345a1.19 1.19 0 00-1.665 0 1.19 1.19 0 000 1.665l2.855 2.854zm-.06 8.308L3.242 19.07a1.207 1.207 0 001.69 1.69l2.897-2.897L10 20.034V14H3.965l2.173 2.172zM17.743 7.86l2.924-2.854a1.204 1.204 0 000-1.665 1.156 1.156 0 00-1.637 0l-2.807 2.973L14 4.053V10h5.847l-2.105-2.14z" fill="#ffffff"></path></svg>
                    :
                    <img src="/images/New/SipSaheli/ESC.png" width="27" height="27" onClick={handleFullscreen} className="fullscreen"/>
                    // <svg onClick={handleFullscreen} width="27" height="27" data-v-71c99c82="" version="1.1" viewBox="0 0 24 24" class="svg-icon svg-fill fullscreen cursorOtp" focusable="false"><path pid="0" d="M6.733 5.1l2.1-2.1H3v5.833l2.1-2.1 2.8 2.8A1.167 1.167 0 109.533 7.9l-2.8-2.8zM18.9 17.328l-2.8-2.869a1.18 1.18 0 00-1.633-.23 1.135 1.135 0 000 1.837l2.916 2.754L15.167 21H21v-5.738l-2.1 2.066zm-3.014-7.664l2.854-2.806L21 8.845V3h-5.947l2.141 2.104L14.34 7.91a1.155 1.155 0 000 1.637.96.96 0 001.546.117zm-7.857 4.673L5.222 17.26 3 15.156v5.847h5.847l-2.105-2.105 2.924-2.807a1.17 1.17 0 000-1.637 1.052 1.052 0 00-1.637-.117z" fill="#ffffff"></path></svg>
                    }
                  </div>
                : ""
                }
              </>
            )
          })}
        {/* {dataSubmited && dataSubmited.status == true ?
        (<div className="thanyoudiv">
          <img src="/images/New/SipSaheli/successverifiedicon.svg" />
          <p className="thanktitle">Thank you!</p>
          <p className="thanksubtitle">we are excited to have you join us.</p>
          <p className="thanksubtitle mb-3">Event details have been sent on your email and mobile.</p>
          <p className="details">Booking Details</p>
          <div className="detailsdiv">
            <p>Language: <span>{dataSubmited && dataSubmited.sessionLanguage}</span></p>
            <p>Date: <span>{dataSubmited && dataSubmited.sessionDate}</span></p>
            <p>Session Time: <span>{dataSubmited && dataSubmited.sessionTime}</span></p>
          </div>
        </div>) */}
        {/* <>
          {dataSubmited && dataSubmited.videoUrl && dataSubmited.videoUrl.url ?
            <div className="registerplayer" ref={playerWrapperRef}>
              <ReactPlayer
                url={dataSubmited && dataSubmited.videoUrl && dataSubmited.videoUrl.url}
                controls={false}
                className={isFullscreen ? "player videoplayer" : "videoplayer"}
                muted={false}
                playing={true}
              />
              {isFullscreen ?
              <img src="/images/New/SipSaheli/fullscreen.png" width="27" height="27" onClick={handleExitFullscreen} className="fullscreen"/>
              // <svg  width="27" height="27" data-v-71c99c82="" version="1.1" viewBox="0 0 24 24" class="svg-icon svg-fill fullscreen cursorOtp" focusable="false"><path pid="0" d="M20.664 19.114l-2.806-2.854L19.845 14H14v5.947l2.104-2.141 2.806 2.854a1.155 1.155 0 001.637 0 .96.96 0 00.117-1.546zM6.197 7.864l-2.141 2.14h5.947V4.059L7.862 6.2 5.007 3.345a1.19 1.19 0 00-1.665 0 1.19 1.19 0 000 1.665l2.855 2.854zm-.06 8.308L3.242 19.07a1.207 1.207 0 001.69 1.69l2.897-2.897L10 20.034V14H3.965l2.173 2.172zM17.743 7.86l2.924-2.854a1.204 1.204 0 000-1.665 1.156 1.156 0 00-1.637 0l-2.807 2.973L14 4.053V10h5.847l-2.105-2.14z" fill="#ffffff"></path></svg>
              :
              <img src="/images/New/SipSaheli/ESC.png" width="27" height="27" onClick={handleFullscreen} className="fullscreen"/>
              // <svg onClick={handleFullscreen} width="27" height="27" data-v-71c99c82="" version="1.1" viewBox="0 0 24 24" class="svg-icon svg-fill fullscreen cursorOtp" focusable="false"><path pid="0" d="M6.733 5.1l2.1-2.1H3v5.833l2.1-2.1 2.8 2.8A1.167 1.167 0 109.533 7.9l-2.8-2.8zM18.9 17.328l-2.8-2.869a1.18 1.18 0 00-1.633-.23 1.135 1.135 0 000 1.837l2.916 2.754L15.167 21H21v-5.738l-2.1 2.066zm-3.014-7.664l2.854-2.806L21 8.845V3h-5.947l2.141 2.104L14.34 7.91a1.155 1.155 0 000 1.637.96.96 0 001.546.117zm-7.857 4.673L5.222 17.26 3 15.156v5.847h5.847l-2.105-2.105 2.924-2.807a1.17 1.17 0 000-1.637 1.052 1.052 0 00-1.637-.117z" fill="#ffffff"></path></svg>
              }
            </div>
          :''}
        </>
         : 
        <p>{dataSubmited && dataSubmited.message}</p>} */}
        </div>
        :
        <div className="container mt-4">
          <div className="mb-3">
            <h2 className="main-title">{womenData && womenData.title ? womenData.title : ''}</h2>
            <p className="sub-title mt-1">{womenData && womenData.summary ? womenData.summary : ''}</p>
          </div>

          <div className="webinardetail my-3">
            <div className="row">
              <div className="col-md-12">
                <img
                  src={womenData && womenData.banner && womenData.banner.url ? womenData.banner.url : ''}
                  className="banner-img"
                  alt={womenData && womenData.banner && womenData.banner.alt ? womenData.banner.alt : ''}
                />
              </div>
              <div className="col-md-6 mb-3">
                <div className="aboutdiv newmasterclass h-100">
                  <h2 className="masterclass">Begin your Masterclass now!</h2>
                  <p className="mastertext">Select your preferred language to start</p>
                  <div className="langCTA p-md-4">
                    <div className="session">                  
                      <div className="session-options daydiv">
                        {['English', 'Hindi'].map(language => (
                          <div
                            key={language}
                            className="day sessionlang text-center"
                            onClick={()=>handleclicklanguage(language)}
                          >
                            <img src={language == "Hindi" ? "/images/New/SipSaheli/hindiSip.svg" : "/images/New/SipSaheli/englishSip.svg"} alt="Language" className="me-2" width="20" height="20" />
                            {language == "Hindi" ? "हिंदी" : "English"}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {isDesktop == false ? 
                <div className="col-md-6 mb-3">
                  <div className="aboutdiv ser">
                    <h3>{womenData && womenData.aboutSipData && womenData.aboutSipData.aboutSipSaheliHeading ? womenData.aboutSipData.aboutSipSaheliHeading : ''}</h3>
                    <div className="row">
                      {womenData &&
                        womenData.aboutSipData &&
                        womenData.aboutSipData.aboutSipSaheliData &&
                        womenData.aboutSipData.aboutSipSaheliData.length > 0 &&
                        womenData.aboutSipData.aboutSipSaheliData.map((item, index) => {
                          return (
                            <div className="col-md-6" key={index}>
                              <div className="d-flex d-flex align-items-start">
                                <img src="/images/New/SipSaheli/blueverify.svg" className="checkicon" />
                                <p>{item}</p>
                              </div>
                            </div>
                          )
                        })}
                    </div>
                  </div>
                </div>
                : ''}
              <div className="col-md-6 mb-3">
                {isDesktop == true ? 
                <div className="aboutdiv">
                  <h3>{womenData && womenData.aboutSipData && womenData.aboutSipData.aboutSipSaheliHeading ? womenData.aboutSipData.aboutSipSaheliHeading : ''}</h3>
                  <div className="row">
                    <div className="col-md-6">
                      {womenData &&
                        womenData.aboutSipData &&
                        womenData.aboutSipData.whatYouwillLearnLeftData &&
                        womenData.aboutSipData.whatYouwillLearnLeftData.length > 0 &&
                        womenData.aboutSipData.whatYouwillLearnLeftData.map((item, index) => {
                          return (
                            <div key={index}>
                              <div className="d-flex d-flex align-items-start">
                                <img src="/images/New/SipSaheli/blueverify.svg" className="checkicon" />
                                <p>{item}</p>
                              </div>
                            </div>
                          )
                        })}
                    </div>
                    <div className="col-md-6">
                      {womenData &&
                        womenData.aboutSipData &&
                        womenData.aboutSipData.whatYouwillLearnRightData &&
                        womenData.aboutSipData.whatYouwillLearnRightData.length > 0 &&
                        womenData.aboutSipData.whatYouwillLearnRightData.map((item, index) => {
                          return (
                            <div key={index}>
                              <div className="d-flex d-flex align-items-start">
                                <img src="/images/New/SipSaheli/blueverify.svg" className="checkicon" />
                                <p>{item}</p>
                              </div>
                            </div>
                          )
                        })}
                    </div>
                  </div>
                </div>
                : ''}
              </div>
              {/* <div className="col-md-4"> */}
                {/* <div className="register p-4">
                  <p className="mb-4 headtext text-center">
                    Register for SIP Saheli
                  </p>
                  <form onSubmit={formik.handleSubmit} > */}
                    {/* <div className={`position-relative form-floating ${formik.values.firstname ? "active-input" : ""} `}>
                      <input
                        type="text"
                        id="firstname"
                        name="firstname"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.firstname}
                        className={
                          "invalid form-control" +
                          (formik.errors.firstname && formik.touched.firstname
                            ? " is-invalid"
                            : "")
                        }
                      />
                      <label for="floatingname" className="input-label">
                        Name<span className="astric">*</span>
                      </label>
                      <div className="invalid-feedback">
                        {formik.errors.firstname && formik.touched.firstname
                          ? formik.errors.firstname
                          : null}
                      </div>
                    </div> */}
                    {/* <div className={`position-relative form-floating mt-4 ${formik.values.lastname ? "active-input" : ""} `}>
                  <input
                    type="text"
                    id="lastname"
                    name="lastname"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.lastname}
                    className={
                      "invalid form-control" +
                      (formik.errors.lastname && formik.touched.lastname
                        ? " is-invalid"
                        : "")
                      }
                  />
                  <label for="floatingname" className="input-label">
                    Last name<span className="astric">*</span>
                  </label>
                  <div className="invalid-feedback">
                    {formik.errors.lastname && formik.touched.lastname
                      ? formik.errors.lastname
                      : null}
                  </div>
                </div> */}
                    {/* <div className={`position-relative form-floating mt-4 ${formik.values.floatingemail ? "active-input" : ""} `}>
                      <input
                        type="email"
                        id="floatingemail"
                        name="floatingemail"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.floatingemail}
                        className={
                          "invalid form-control" +
                          (formik.errors.floatingemail && formik.touched.floatingemail
                            ? " is-invalid"
                            : "")
                        }
                      />
                      <label for="floatingemail" className="input-label">
                        Email<span className="astric">*</span>
                      </label>
                      <div className="invalid-feedback">
                        {formik.errors.floatingemail && formik.touched.floatingemail
                          ? formik.errors.floatingemail
                          : null}
                      </div>
                    </div> */}
                    {/* <div className={`position-relative form-floating mt-4 ${formik.values.mobile ? "active-input" : ""} `}>
                      <input
                        type="text"
                        id="mobile"
                        name="mobile"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.mobile}
                        // disabled={verify || seconds !== 0}
                        onKeyPress={(event) => {
                          if (!/^[0-9.\b]+$/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        onPaste={(event) => {
                          if (!/^[0-9.\b]+$/.test(event)) {
                            event.preventDefault();
                          }
                        }}
                        maxLength={10}
                        className={
                          "invalid form-control" +
                          (formik.errors.mobile && formik.touched.mobile
                            ? " is-invalid"
                            : "")
                        }
                      />
                      <label for="floatingNumber" className="input-label">
                        Mobile Number<span className="astric">*</span>
                      </label>
                      <div className="invalid-feedback">
                        {formik.errors.mobile && formik.touched.mobile
                          ? formik.errors.mobile
                          : null}
                      </div>

                    </div> */}
                    {/* <div className="Session">
                    <label className="labeltxt">
                      Session Language<span className="astric">*</span>
                    </label>                      
                    <div className={`session-options daydiv ${formik.errors.sessionLanguage ? "is-invalid" : ""}`}>
                    {['English', 'Hindi'].map(language => (
                      <div
                        key={language}
                        className={`day sessionlang text-center ${formik.values.sessionLanguage === language ? 'active' : ''}`}
                        onClick={() => formik.setFieldValue('sessionLanguage', language)}
                      >
                        {language == "Hindi" ? "हिंदी" : "English"}
                      </div>
                    ))}
                  </div>
                  <div className="invalid-feedback">
                    {formik.errors.sessionLanguage && formik.touched.sessionLanguage
                      ? formik.errors.sessionLanguage
                      : null}
                  </div>
                </div> */}
                    {/* <div className="Session">
                      <label className="labeltxt">
                        Session Date<span className="astric">*</span>
                      </label>
                      <div className={`session-options daydiv sessioncls ${formik.errors.sessionDay ? "is-invalid" : ""}`}>
                        {womenData && womenData.sessionData && womenData.sessionData.map(day => (
                          <div
                            key={day.webinarDate}
                            className={`day ${formik.values.sessionDay === day.webinarDate ? 'active' : ''}`}
                            onClick={() => formik.setFieldValue('sessionDay', day.webinarDate)}
                          >
                            {day.webinarDate}
                          </div>
                        ))}
                      </div>
                      <div className="invalid-feedback">
                        {formik.errors.sessionDay && formik.touched.sessionDay
                          ? formik.errors.sessionDay
                          : null}
                      </div>
                    </div>
                    {formik.values.sessionDay ?
                      (<div className="Session">
                        <label className="labeltxt">
                          Session Time<span className="astric">*</span>
                        </label>
                        <div className={`session-options daydiv sessioncls ${formik.errors.sessionTime ? "is-invalid" : ""}`}>
                          {womenData && womenData.sessionData && womenData.sessionData.filter(day => day.webinarDate === formik.values.sessionDay)
                            .map(day => (
                              day.timeSlots.map(time => (
                                <div
                                  key={time.time}
                                  className={`day time ${formik.values.sessionTime === time.time ? 'active' : ''}`}
                                  onClick={() => formik.setFieldValue('sessionTime', time.time)}
                                >
                                  {time.time}
                                </div>))
                            ))}
                        </div>
                        <div className="invalid-feedback">
                          {formik.errors.sessionTime && formik.touched.sessionTime
                            ? formik.errors.sessionTime
                            : null}
                        </div>
                      </div>) : ""} */}
                    {/* {lateResponse ? 
                      <button
                        type="submit"
                        className="registerbtn registerdisable cursornone"
                      >
                        Register
                      </button>
                    :
                      <button
                        type="submit"
                        className={!(formik.isValid && formik.dirty) ? "registerbtn registerdisable" : "registerbtn registerenable"}
                        disabled={!(formik.isValid && formik.dirty)}
                        onClick={handleRegister}
                      >
                        Register
                      </button>} */}
                  {/* </form>
                </div> */}
                {/* {isDesktop == false ? <div className="aboutdiv ser">
                  <h3>{womenData && womenData.aboutSipData && womenData.aboutSipData.aboutSipSaheliHeading ? womenData.aboutSipData.aboutSipSaheliHeading : ''}</h3>
                  <div className="row">
                    {womenData &&
                      womenData.aboutSipData &&
                      womenData.aboutSipData.aboutSipSaheliData &&
                      womenData.aboutSipData.aboutSipSaheliData.length > 0 &&
                      womenData.aboutSipData.aboutSipSaheliData.map((item, index) => {
                        return (
                          <div className="col-md-6">
                            <div className="d-flex d-flex align-items-start">
                              <img src="/images/New/SipSaheli/blueverify.svg" className="checkicon" />
                              <p>{item}</p>
                            </div>
                          </div>
                        )
                      })}
                  </div>
                </div>
                : ''}
              </div> */}
            </div>
            <div className="row mt-4">
              <div className="col-md-12">
              {womenData && womenData.description ?
                <div
                  dangerouslySetInnerHTML={{
                    __html: womenData.description,
                  }}
                />
                : ''}
              </div>
            </div>
            {/* <div className="row mt-4">
              <div className="col-md-8">
                <ReactPlayer
                  url={
                    womenData && womenData.video && womenData.video.url
                      ? womenData.video.url
                      : ""
                  }
                  controls="true"
                  className="sipvideoplayer"
                  muted={true}
                  playing={false}
                />
                {womenData && womenData.belowVideoDescription ?
                  <div className="quoteline"
                    dangerouslySetInnerHTML={{
                      __html: womenData.belowVideoDescription,
                    }}
                  />
                  : ''}
              </div>
              <div className="col-md-4">
                <div className="d-flex paradiv">
                  <p className="quotediv">“</p>
                  <p className="quoteline">Please ro announced that our company has achived a significant milestone in our investment journey. This success is testament to our team's hard work, dedication and commitment. This success is testament to our team's hard work, dedication and commitment.</p>
                  {womenData && womenData.body ?
                    <div className="quoteline"
                      dangerouslySetInnerHTML={{
                        __html: womenData.body,
                      }}
                    />
                    : ''}
                </div>
              </div>
            </div> */}
          </div>
          <div className="awarenessdiv">
            <div className="line w-75"></div>
              <p className="title">Disclaimer</p>
              <p className="subtitle bold">An Investor Education and Awareness Initiative</p>
              <p className="subtitle">
                Visit <a  className="blue" href="/information/key-know-how">https://www.hdfcfund.com/information/key-know-how</a> to know more about the process to complete a one-time Know Your Customer (KYC) requirement to invest in Mutual Funds. Investors should only deal with registered Mutual Funds, details of which can be verified on the SEBI website (www.sebi.gov.in/intermediaries.html). For any queries, complaints & grievance redressal, investors may reach out to the AMCs and / or Investor Relations Officers. Additionally, investors may also lodge complaints directly with the AMCs. If they are not satisfied with the resolutions given by AMCs, they may raise complaint through the SCORES portal on <a className="blue" href="https://scores.gov.in">https://scores.gov.in</a>. SCORES portal facilitates investors to lodge complaint online with SEBI and subsequently view its status. In case the investor is not satisfied with the resolution of the complaints raised directly with the AMCs or through the SCORES portal, they may file any complaint on the Smart ODR on <a className="blue" href="https://smartodr.in/login">https://smartodr.in/login.</a>
              </p>
              {/* <p className="subtitle">To switch section of what you'll learn in class & <span className="fw-bold">How can SIP Saheli help you take charge of your financial future?</span></p> */}
            <div className="line w-75"></div>
          </div>
        </div>
      }
      {/* } */}
      </section>

    </div>
  );
};

const mapStateToProps = (state) => ({
  IAPWomenData: state.iapWomen.registrationData,
  // RegisterDataaa: state.iapWomen.registerRegistrationData,
  registrationMedia: state.iapWomen.registerMediaData,
});

const mapDispatchToProps = (dispatch) => ({
  getIAPRegistrationData: bindActionCreators(getIAPRegistrationData, dispatch),
  RegisterRegistration: bindActionCreators(RegisterRegistration, dispatch),
  getRegistrationMedia: bindActionCreators(getRegistrationMedia, dispatch),
});

const IAPWomenRegistrationContainer = connect(mapStateToProps, mapDispatchToProps)(Registration);
export default IAPWomenRegistrationContainer;